import { jeepRallyApi } from "../api";

const routesBaseUrl = "/api/v1/routes";
const checkpointsBaseUrl = "/api/v1/checkpoints";

export const getRouteCheckpoints = (routeId, params = {}) => {
  return jeepRallyApi.get(`${routesBaseUrl}/${routeId}/checkpoints`, {
    params,
  });
};

export const getStageCheckpoints = (params) => {
  return jeepRallyApi.get(checkpointsBaseUrl, { params });
};

export const addRouteCheckpoint = (routeId, payload) => {
  return jeepRallyApi.post(`${routesBaseUrl}/${routeId}/checkpoints`, payload);
};

export const replaceRouteCheckpoints = (routeId, payload) => {
  return jeepRallyApi.put(`${routesBaseUrl}/${routeId}/checkpoints`, payload);
};

export const updateCheckpoint = (checkpointId, payload) => {
  return jeepRallyApi.patch(`${checkpointsBaseUrl}/${checkpointId}`, payload);
};

export const uploadCheckpointImage = (checkpointId, file) => {
  const formData = new FormData();
  formData.append("image", file);
  return jeepRallyApi.patch(
    `${checkpointsBaseUrl}/${checkpointId}/image`,
    formData
  );
};

export const deleteCheckpoint = (checkpointId) => {
  return jeepRallyApi.delete(`${checkpointsBaseUrl}/${checkpointId}`);
};
